<template>
  <div id="body">
    <el-container>
      <el-header><div class="left">欢迎访问四川省招生考试书城！</div></el-header>
      <el-header><img class="top" src="../img/微信图片_20240308102119(1).png"><img class="GSSY" src="../img/20240301112918.png"><h1 class="title">四川省招生考试书城</h1><div class="BY">聚焦考试招生 &nbsp;&nbsp; 书写精彩人生</div></el-header>
      <el-main><router-view></router-view></el-main>
      <el-footer><Footer/></el-footer>
      <el-footer>版权所有：四川省锦兴国试书业有限公司 未经授权不得复制、转载、建立镜像</el-footer>
    </el-container>
  </div>
</template>

<script>
import Footer from './Footer.vue'

export default {
  name: 'Index',
  components: {
    Footer,
  },
  props: {
    msg: String
  },
  created(){
    var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?f33b2579019e780cc4a6ed33dfbb1079";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
  }
}
</script>

<style scoped>
#body {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}
.el-header:nth-child(1) {
  background-color: #f5f6f6;
  text-align: left;
  line-height: 29px;
  height: 29px;
  width: 1920px;
}
.BY {
  position: relative;
  float: left;
  height: 45px;
  width: 460px;
  text-align: center;
  margin-left: 780px;
  margin-top: -692px;
  font-size: 30px;
  line-height: 45px;
  font-weight: 600;
  color: #3677cd;
  background: linear-gradient(to right, rgba(0,0,0,0), #ffffff, rgba(0,0,0,0));
  display: none;
}
.title {
  position: relative;
  float: left;
  margin-left: 380px;
  margin-top: -845px;
  font-size: 40px;
  font-weight: 600;
  text-shadow: #565a5d 4px 4px 5px;
  color: #ffffff;
  display: none;
}
.GSSY {
  position: relative;
  float: left;
  margin-left: 270px;
  margin-top: -810px;
  width: 80px;
  height: 80px;
  display: none;
}
.top {                                          
  width: 1920px;
  height: 220px; 
}

.el-header:nth-child(2) {
  background-color: #ffffff;
  line-height: 140px;
  height: 220px;
  width: 1920px;
}
.el-header {
  padding: 0px;
}

.el-footer:last-child {
  background-color: #4e5357;
  color: #b9b4b4;
  text-align: center;
  line-height: 29px;
  font-size: 16px;
  height: 45px;
  padding-top: 10px;
  width: 1920px;
}

.el-footer {
  background-color: #565a5d;
  height: 100%;
  font-size: 16px;
  width: 1920px;
}

.left {
  float: left;
  margin-left: 270px;
  font-size: 16px;
}

.el-main {
  background-color: #ffffff;
  color: #333;
  text-align: center;
  height: 100%;
  width: 1920px;
}


</style>